import NamedDto from 'modules/base/dto/NamedDto';
import ClassificationAlgorithmStatus from './ClassificationAlgorithmStatus';

export default class DeviceSelectionDto extends NamedDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.infrastructureElement = null;
		/** @type {NamedDto} */
		this.location = null;
	}

	/**
	 * @typedef {Object} _DeviceSelectionDtoProps
	 * @property {NamedDto} infrastructureElement
	 * @property {NamedDto} location
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _DeviceSelectionDtoProps} DeviceSelectionDtoProps
	 */
	/**
	 *
	 * @param {DeviceSelectionDtoProps} props
	 * @returns {DeviceSelectionDto}
	 */
	setup(props) {
		super.setup(props);
		console.log(props);
		this.infrastructureElement = props.infrastructureElement !== null ? new NamedDto().setup(props.infrastructureElement) : null;
		this.location = props.location !== null ? new NamedDto().setup(props.location) : null;
		return this;
	}
}
